.root {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.messageContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacingMd);
}

.actions {
  text-align: center;
}

.icon {
  scale: 0.5;
}
